// refactor sass to stylejs (no theme usage)
import UiDialog from 'ui-components/ui-dialog/UiDialog';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledShare = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    .share-modal {
      z-index: 1300 !important;
    }
  `
);

export const StyledShareDialog = styled(UiDialog)(
  () => css`
    &.share-modal {
      .MuiDialogContent-root {
        .label {
          font-weight: normal;
          font-size: 0.875rem;
        }
        padding: 32px 16px !important;
        .social-btn {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          min-width: 56px;
          margin: 18px 0 0 30px;
          .title {
            margin-top: 14px;
          }

          &:last-child {
            margin: 18px 0 0 0;
          }
        }
        .copy-link {
          .address-label {
            font-size: 0.875rem;
            margin-top: 24px;
            margin-bottom: 12px;
          }
          .copy-link-input {
            flex: 1;
            .MuiInputBase-input {
              text-align: left;
            }
          }
          .copy-link-btn {
            margin-right: 10px;
          }
          .copy-link-message {
            font-size: 0.625rem;
            color: #66cb9f;
          }
        }
      }
    }

    @media (max-width: 900px) {
      &.share-modal {
        .dialog-support {
          display: none;
        }

        .MuiPaper-root {
          width: calc(100% - 32px);
          margin: 16px;
        }
      }
    }
  `
);
